/**
 * @author gll
 * 模块说明：采购策略—供应商寻源配置规则项功能
 */
import { Service } from '@/tools'

export class requireConfigSourceItemService<T extends TProcure.RequireConfigSourceItem> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TProcure.RequireConfigSourceItem}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 模块说明：查询寻源规则项字典数据集合
   * /api/procure/require/config/source/item/v1/list
   */
  list = <K extends T['ApiList']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiList', data)
  }
}
